import axios, {AxiosRequestConfig} from 'axios'
import {AUTH_LOG_USER_OUT, SET_INVALID_TOKEN} from "@/store/action-types";
import store from '@/store'
import auth from '@/store/modules/auth'
import router from '@/router'

function addDefaultHeadersInterceptor(config: AxiosRequestConfig): any {
    config.headers.get['Accept'] = 'application/json'

    if (config.method && config.headers && config.headers[config.method]) {
        config.headers[config.method]['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    }

    return config
}

const config = {
    baseURL: process.env.VUE_APP_API_ROOT
}

const instance = axios.create(config)

instance.interceptors.request.use(addDefaultHeadersInterceptor)

instance.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (axios.isCancel(error)) {

    } else {
        if (error.response.status === 401) {
            if (auth.state.currentUser) {
                store.dispatch(SET_INVALID_TOKEN, true)
            }
            store.dispatch(AUTH_LOG_USER_OUT)
            // a 401 while already on the login page must not re-navigate —
            // vue-router raises NavigationDuplicated as an uncaught error
            if (router.currentRoute.name !== 'Login') {
                router.push({name: 'Login'}).catch(() => undefined)
            }
        }
    }
    return Promise.reject(error)
})

export default instance
